import React from 'react'
import {Box, Typography} from '@material-ui/core'
import MuiExpansionPanel from '@material-ui/core/Accordion'
import MuiExpansionPanelSummary from '@material-ui/core/AccordionSummary'
import MuiExpansionPanelDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import {withStyles, makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: 48,
        right: 40,
        borderRadius: '0px',
        width: '460px',
        maxHeight: '80vh',
        overflow: 'auto',
        whiteSpace: 'normal',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '320px',
            maxHeight: '75vh',
            right: 0,
        },
    },
    circle: {
        boxSizing: 'border-box',
        borderRadius: '50%',
        backgroundColor: theme.palette.common.white,
        height: '38px',
        width: '38px',
        padding: '1px 1px 1px 1px',
        '&:hover': {
            opacity: 0.8,
            backgroundColor: theme.palette.common.white,
            transition: 'border-color 0.2s, border-width 0.2s',
        },
    },
    helpsubheader: {
        fontWeight: theme.typography.body1.bold.fontWeight,
    },
    text: {
        alignItems: 'flex-start',
        font: 'Regular 0.8125rem/1.1875rem Montserrat',
        letterSpacing: 0,
        color: '#262626',
        opacity: 1,
    },
}))

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel)

const ExpansionPanelSummary = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.common.white,
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: '3.5rem',
        '&$expanded': {
            backgroundColor: theme.palette.grey.pale,
            minHeight: '3.5rem',
        },
    },
    content: {
        '&$expanded': {
            margin: '0.75rem 0',
        },
    },
    expanded: {},
}))(MuiExpansionPanelSummary)

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiExpansionPanelDetails)

const HelpContentDeptAdmin = props => {
    const classes = useStyles()

    const {expanded, handleChange} = props

    return (
        <>
            <ExpansionPanel
                square
                expanded={expanded === 'panel8'}
                onChange={handleChange('panel8')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel8bh-content"
                    id="panel8bh-header"
                >
                    <Typography variant="subtitle1">
                        How to Manage Roles
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <div className={classes.text}>
                            <ol>
                                <li>Click on the {'“Manage Roles”'} tab.</li>
                                <li>
                                    Select your desired department in the drawer
                                    on the left.
                                </li>
                                <li>Click {'“Assign Role”'}</li>
                                <li>
                                    Add a user by EUID, ID Number, or Name
                                    Lookup.
                                </li>
                                <li>Select a role from the drop-down.</li>
                                <li>Click {'“Assign Role”'} to save.</li>
                            </ol>
                        </div>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel
                square
                expanded={expanded === 'panel9'}
                onChange={handleChange('panel9')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel9bh-content"
                    id="panel9bh-header"
                >
                    <Typography variant="subtitle1">Managing Roles</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <div className={classes.text}>
                            <ol>
                                <li>
                                    To edit a user’s role, click on their name.
                                </li>
                                <li>
                                    To remove a user’s role, click on the
                                    checkbox next to their name, then click the
                                    trash can icon that appears.
                                </li>
                            </ol>
                        </div>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </>
    )
}

export default HelpContentDeptAdmin
